<template>
    <q-dialog ref="dialog" @hide="onDialogHide" persistent>
        <q-card class="q-dialog-plugin " style="width: 30vw; max-width: 90vw;">
            <q-toolbar class="bg-primary text-white">
                <q-toolbar-title v-text="(actionTitle + ' ' + screenTitle).trim()"></q-toolbar-title>
                <q-btn flat round dense icon="close" v-close-popup></q-btn>
            </q-toolbar>

            <q-form ref="modelForm">
                <q-card-section>
                    <div class="flex column wrap">
                        <div class="row q-col-gutter-lg">
                            <div class="col-12" >
                            <q-select v-model="model.SenderCode" 
                                      label="Canonical Code *" 
                                      autofocus 
                                       
                                      :options="dataSourceLookupCanonicalCodes" option-value="Key" option-label="Value"
                                      emit-value map-options 
                                       
                                      :rules="[val => !!val || 'Required',]"
                                      :error="fieldHasError('SenderCode')"
                                      :error-message="fieldErrorMessage('SenderCode')"
                                      
                                      @input="onSenderCodeChange(model, ...arguments)"
                                      
                                      dense options-dense>
                                
                                
                                
                            </q-select>
                        </div>
<div class="col-6" >
                            <q-input v-model="model.Value1" type="text" 
                                     label="Carrier *" 
                                      
                                      maxlength="255"
                                      
                                     :rules="[val => val && val.length > 0 || 'Required',]"
                                     :error="fieldHasError('Value1')"
                                     :error-message="fieldErrorMessage('Value1')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-6" >
                            <q-input v-model="model.Value2" type="text" 
                                     label="Service *" 
                                      
                                      maxlength="255"
                                      
                                     :rules="[val => val && val.length > 0 || 'Required',]"
                                     :error="fieldHasError('Value2')"
                                     :error-message="fieldErrorMessage('Value2')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-6" >
                            <q-select v-model="model.MappingDirection" 
                                      label="Mapping Direction" 
                                       
                                       
                                      :options="dataSourceCarrierMappingDirectionType" option-value="Key" option-label="Value"
                                      emit-value map-options 
                                       
                                      :rules="[]"
                                      :error="fieldHasError('MappingDirection')"
                                      :error-message="fieldErrorMessage('MappingDirection')"
                                      
                                      @input="onMappingDirectionChange(model, ...arguments)"
                                      
                                      dense options-dense>
                                
                                
                                
                            </q-select>
                        </div>
<div class="col-6" >
                            <q-select v-model="model.CarrierType" 
                                      label="Carrier Type" 
                                       
                                       
                                      :options="dataSourceCarrierType" option-value="Key" option-label="Value"
                                      emit-value map-options 
                                       readonly
                                      :rules="[]"
                                      :error="fieldHasError('CarrierType')"
                                      :error-message="fieldErrorMessage('CarrierType')"
                                      
                                      @input="onCarrierTypeChange(model, ...arguments)"
                                      
                                      dense options-dense>
                                
                                
                                
                            </q-select>
                        </div>
<div class="col-12" >
                            <q-input v-model="model.Description" type="text" 
                                     label="Description" 
                                      
                                      maxlength="255"
                                      
                                     :rules="[]"
                                     :error="fieldHasError('Description')"
                                     :error-message="fieldErrorMessage('Description')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-12" >
                            <q-input v-model="model.Comments" type="textarea" rows="8" 
                                     label="Comments" 
                                      
                                      
                                      
                                     :rules="[]"
                                     :error="fieldHasError('Comments')"
                                     :error-message="fieldErrorMessage('Comments')"
                                     
                                     dense>
                                
                                
                            </q-input>
                        </div>

                        </div>
                    </div>
                </q-card-section>
            </q-form>

            <q-toolbar>
                <div class="q-gutter-xs">
                    
                </div>

                <q-space></q-space>

                <div class="q-gutter-xs" v-if="editMode === true">
                    
                    <q-btn color="primary" :label="actionLabel" @click="onOkClick" :disable="actionLocked"></q-btn>
                    <q-btn color="white" text-color="black" label="Cancel" @click="onCancelClick" :disable="actionLocked"></q-btn>
                </div>
                <div class="q-gutter-xs" v-if="editMode === false">
                    
                    <q-btn color="white" text-color="black" label="Close" @click="onCancelClick" :disable="actionLocked"></q-btn>
                </div>
            </q-toolbar>

            <q-inner-loading :showing="loading">
                <q-spinner-gears size="50px" color="primary"></q-spinner-gears>
            </q-inner-loading>
        </q-card>
    </q-dialog>
</template>

<style>
    
</style>

<script>
    export { default } from './carrieraddeditmodel-dialog-screen.js'
</script>